(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rxjs"), require("helpful-merge"), require("globx"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["rxjs", "helpful-merge", "globx", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["daznPlayer"] = factory(require("rxjs"), require("helpful-merge"), require("globx"), require("react"), require("react-dom"));
	else
		root["daznPlayer"] = factory(root["rxjs"], root["helpful-merge"], root["globx"], root["react"], root["react-dom"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__56__, __WEBPACK_EXTERNAL_MODULE__77__, __WEBPACK_EXTERNAL_MODULE__78__) {
return 